import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { DashboardTemplateResponse } from "../../models/DashboardTemplateResponse";
import DashboardView from "../DashboardView/DashboardView.vue";

@Component({
  name: "DashboardPreview",
  components: {
    DashboardView
  }
})
export default class DashboardPreview extends Vue {
  @Prop() realDashboard?: boolean;
  @Prop() dashboardTemplate?: DashboardTemplateResponse;

  @Emit("close")
  onClose() {
    return;
  }
}
